import Axios from 'axios';
import Url from './request-url.js';
import { MessageBox, Message } from 'element-ui';
import Router from './../router.js';
import Store from './../store.js';

//请求方式：get、post
//url:请求的参数,判断前面字符是否http://或https://开头，是则直接用传进来的，不是则用BaseUrl+url
//reqParams:请求参数
//errorShowType:错误提示类型，（空字符串''：为Message弹框，字符串'msgBox'：为MessageBox弹窗，字符串'false'：为不提示）

//延迟毫秒数
const timeoutMs = 120000;

//基础链接地址
let baseUrlStr = Url.getRequestBaseUrl();


export default {
    //get请求
    get: (url, reqParams, errorShowType) => {
        return new Promise((resolve, reject) => {
            Axios({
                responseType: 'json',
                method: 'get',
                timeout: timeoutMs,
                params: reqParams,
                url: url,
                baseURL: checkUrlHasHttp(url) ? undefined : baseUrlStr
            }).then(response => {
                responseHandle(response, resolve, reject, errorShowType);
            });
        });
    },
    //post请求
    post: (url, reqParams, errorShowType, isUseDefaultHandle = true, selfResHandle) => {
        return new Promise((resolve, reject) => {
            Axios({
                responseType: 'json',
                method: 'post',
                timeout: timeoutMs,
                data: reqParams,
                url: url,
                baseURL: checkUrlHasHttp(url) ? undefined : baseUrlStr
            }).then(response => {
                responseHandle(response, resolve, reject, errorShowType);
            });
        });
    }
}

//请求拦截
Axios.interceptors.request.use(
    config => {

        config.cancelToken = new Axios.CancelToken(cancel => {
            Store.commit("pushReqCancel", cancel);
        });

        if(config.url.indexOf('/UploadFiles') > -1){
            config.headers['Content-Type'] = 'multipart/form-data';
        }

        if (Store.state.token) {
            config.headers.Authorization = 'Bearer ' + Store.state.token;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    },
)

//返回拦截
Axios.interceptors.response.use(response => response, error => {
    if (error.message == "canclereq-01") {
        return Promise.resolve("canclereq-01");
    }
    else {
        return Promise.resolve(error.response);
    }
});

//请求结果处理
function responseHandle(response, resolve, reject, errorShowType) {
    if (response) {
        if (response == "canclereq-01") {
            console.log("canclereq01");
            return;
        }
        switch (response.status) {
            //成功
            case 200:
                resolve(response.data);
                break;
            //功能层面错误
            case 202: case 500:
                showError(response.data.msg, errorShowType);
                Store.commit("cleanHeartInterval");
                reject(response.data);
                break;
            //授权失败，跳去登录
            case 401:
                Store.commit("cleanHeartInterval");
                reject(response.data);
                if(Router.currentRoute.path.indexOf("referee")!==-1) {
                    Router.replace({ path: '/referee/login', query: { redirect: Router.currentRoute.path == "/referee/login" ? "" : Router.currentRoute.path } });
                } else {
                    Router.replace({ path: '/login', query: { redirect: Router.currentRoute.path == "/login" ? "" : Router.currentRoute.path } });
                }
                break;
            //蜜汁错误
            default:
                Store.commit("cleanHeartInterval");
                const defaultError = "出现错误，请联系IT";
                showError(defaultError, errorShowType);
                reject(defaultError);
                break;
        }
    }
    else {
        Store.commit("cleanHeartInterval");
        const noResponseError = "网络出现异常，请联系IT或稍后再试";
        showError(noResponseError, errorShowType);
        reject(noResponseError);
    }
}

//错误消息提示
function showError(msg, type = "") {
    if (type != "false") {
        if (type == "msgBox") {
            MessageBox.alert(msg, {
                type: "error"
            });
        }
        else {
            Message.error(msg);
        }
    }
}

//检查是否http://或https://开头开头
function checkUrlHasHttp(str) {
    let reg = /(http|https):\/\/([\w.]+\/?)\S*/i;
    return reg.test(str);
}